import React from 'react'
import { Alert, Button, MenuItem, Stack, TextField, Typography } from '@mui/material'
import { AdminSectionCard } from './AdminConsoleShell'

export default function WorkflowWidgetPreconfigPanel({
  workflowWidgetCatalog,
  workflowPresetRows,
  catalogSaved,
  onChangeDefaultPreset,
  onSaveCatalog,
  onResetCatalog,
}) {
  return (
    <AdminSectionCard
      title="Preconfiguración de workflow widgets"
      subtitle="Catálogo no-code para workflow_stage_banner consumido por PropertiesSidebar."
    >
      <Stack spacing={2}>
        <Typography variant="body2" color="text.secondary">
          Selecciona el preset por defecto para nuevos widgets de etapa.
        </Typography>

        <TextField
          select
          label="Preset por defecto"
          value={workflowWidgetCatalog?.workflow_stage_banner?.defaultPreset || ''}
          onChange={(e) => onChangeDefaultPreset(e.target.value)}
          sx={{ maxWidth: 420 }}
        >
          <MenuItem value="">Sin preset por defecto</MenuItem>
          {workflowPresetRows.map((preset) => (
            <MenuItem key={preset.value} value={preset.value}>
              {preset.label}
            </MenuItem>
          ))}
        </TextField>

        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.25}>
          <Button variant="contained" onClick={onSaveCatalog}>
            Guardar catálogo
          </Button>
          <Button variant="outlined" onClick={onResetCatalog}>
            Restablecer catálogo
          </Button>
        </Stack>

        {catalogSaved ? <Alert severity="success">{catalogSaved}</Alert> : null}
      </Stack>
    </AdminSectionCard>
  )
}
